<template>
  <div class="container">
    <BaseFrame
      :breadcrumb="[
        {
          name: 'order',
          title: '采购订单列表'
        },
        {
          name: 'orderInfo',
          title: '订单详情'
        }
      ]"
      :btns="btns"
      @btn-click="onBtnClick"
    >
      <div slot="info">
        <div class="info-container">
          <div class="info-item">
            <h4>采购订单号：{{purchaseOrder.code}}</h4>
            <div>创建时间：{{purchaseOrder.createTime}}</div>
            <div>供应商：{{purchaseOrder.supplierName}}</div>
            <div>成本类型：{{purchaseOrder.paymentName}}</div>
          </div>
          <div class="info-item">
            <h4>采购计划单号：{{purchasePlan.code}}</h4>
            <div>商品类型：{{purchasePlan.goodsTypeName}}</div>
            <div>来源：{{purchasePlan.typeName}}</div>
            <div>采购人：{{purchasePlan.createUserName}}</div>
            <div>创建时间：{{purchasePlan.createTime}}</div>
          </div>
        </div>
      </div>
      <div slot="content">
        <lk-card title="采购商品信息">
          <div class="sum-wrap">
            <div class="title-amount">总商品数量</div>
            <div class="content-amount">{{goodsNum}}</div>
            <div class="title-money">总金额（元）</div>
            <div class="content-money">&yen;{{purchaseAmount}}</div>
          </div>
          <lk-table border :columns='columns' :data='tableData'></lk-table>
        </lk-card>
        <lk-card title="订单已取消" v-if="purchaseOrder.cancelReason" class="cancel-card">
          <div>取消原因：{{purchaseOrder.cancelReason}}</div>
        </lk-card>
      </div>
    </BaseFrame>
    <lk-modal
      v-model="cancelOrderButton"
      title="取消原因"
      :closable="false"
      >

      <lk-form
        label-position="right"
        :label-width="100"
        :model="queryParams"
      >
        <div class="modalTextarea">
          <lk-input placeholder='请输入取消原因' :maxlength="100" clearable v-model.trim="queryParams.cancelReason" type="textarea">
          </lk-input>
        </div>
      </lk-form>
      <div slot="footer">
        <lk-button @click="onModalCancel">取消</lk-button>
        <lk-button type="primary" @click="cancelOrder" :loading="cancelLoading">确定</lk-button>
      </div>
    </lk-modal>
  </div>
</template>

<script>
import BaseFrame from '../../components/frame/NewBaseFrame.vue';
import purchase from '../../services/purchase';
import utils from '../../libs/utils';

export default {
  name: 'orderInfo',
  components: {
    BaseFrame,
  },
  data() {
    return {
      goodsNum: '',
      purchaseAmount: '',
      visible: false,
      cancelOrderButton: false,
      queryParams: {
        purchaseOrderId: '',
        cancelReason: '',
      },
      purchasePlan: {
        code: '',
        goodsType: null,
      },
      orderCancelable: false,
      purchaseOrder: {
        code: '',
        status: '',
        createUserName: '',
        createTime: '',
        cancelReason: '',
      },
      cancelLoading: false,
      columns: [
        {
          title: '行号',
          minWidth: 56,
          render: (h, { index }) => h('span', index + 1),
        },
        {
          title: '商品编码',
          tooltip: true,
          key: 'purchaseMedicineDrugSerialCode',
          minWidth: 82,
        },
        {
          title: '通用名称',
          key: 'medicineInfoVoApprovedDrugNames',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '批准文号',
          key: 'medicineInfoVoApprovalCode',
          tooltip: true,
          minWidth: 116,
        },
        {
          title: '规格',
          key: 'medicineInfoVoSpecifications',
          tooltip: true,
          minWidth: 130,
        },
        {
          title: '商品名称',
          key: 'medicineInfoVoGoodsName',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '剂型',
          key: 'medicineInfoVoDosageFormString',
          tooltip: true,
          minWidth: 116,
        },
        {
          title: '单位',
          key: 'purchaseMedicineDrugMinimumPackagingUnit',
          tooltip: true,
          minWidth: 60,
        },
        {
          title: '产地',
          key: 'purchaseMedicineCountryOfOrigin',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '医保编码',
          width: 200,
          tooltip: true,
          key: 'medicineInfoVoMedicalSerialCode',
        },
        {
          title: '生产企业',
          key: 'medicineInfoVoManufacturer',
          tooltip: true,
          minWidth: 142,
        },
        {
          title: '上市许可持有人',
          minWidth: 142,
          tooltip: true,
          key: 'medicineInfoVoMah',
        },
        {
          title: '已取消数',
          key: 'purchaseMedicineDumpNum',
          tooltip: true,
          minWidth: 82,
        },
        {
          title: '备注',
          key: 'purchaseMedicineComment',
          tooltip: true,
          minWidth: 108,
        },
        {
          title: '采购数量',
          key: 'purchaseMedicineNum',
          minWidth: 90,
          tooltip: true,
          fixed: 'right',
        },
        {
          title: '采购单价',
          key: 'purchaseMedicinePlanPrice',
          minWidth: 90,
          tooltip: true,
          fixed: 'right',
        },
      ],
      tableData: [],
      type: ['待发货', '已全部收货', '已全部验收', '交易取消'],
      paymentType: ['普通', '寄售'],
    };
  },
  computed: {
    btns() {
      if (this.orderCancelable) {
        return [
          {
            name: 'cancel',
            text: '取消订单',
          },
        ];
      }
      return [];
    },
  },
  methods: {
    onBtnClick(name) {
      if (name === 'cancel') {
        this.onModalShow();
      }
    },
    onModalShow() {
      this.cancelOrderButton = true;
    },
    onModalCancel() {
      this.cancelOrderButton = false;
      this.resetCancel();
    },
    resetCancel() {
      this.queryParams.cancelReason = '';
    },
    cancelOrder() {
      this.queryParams.purchaseOrderId = this.$route.params.purchaseOrderId;
      const queryParams = Object.assign({}, this.queryParams);
      if (!queryParams.cancelReason) {
        this.$Message.error('请输入取消原因');
        return;
      }
      this.cancelLoading = true;
      purchase.cancelOrder(queryParams).then((res) => {
        if (res.data.status === 200) {
          this.cancelOrderButton = false;
          this.cancelLoading = false;
          this.resetCancel();
          this.getData();
          this.$Message.success('取消成功');
        } else {
          this.cancelLoading = false;
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData() {
      this.queryParams.purchaseOrderId = this.$route.params.purchaseOrderId;
      this.queryParams.storeId = this.$route.params.belongStore;
      const queryParams = Object.assign({}, this.queryParams);
      // console.log(queryParams);

      purchase.orderInfo(queryParams).then((res) => {
        if (res.data.status === 200) {
          this.tableData = [];
          this.purchaseAmount = res.data.data.purchaseAmount;
          this.goodsNum = res.data.data.goodsNum;
          this.orderCancelable = res.data.data.orderCancelable;
          if (res.data.data.purchaseOrder) {
            this.purchaseOrder.code = res.data.data.purchaseOrder.code;
            this.purchaseOrder.supplierName = res.data.data.purchaseOrder.supplierName;
            this.purchaseOrder.paymentName = this.paymentType[res.data.data.purchaseOrder.payment - 1];
            this.purchaseOrder.cancelReason = res.data.data.purchaseOrder.cancelReason;
            this.purchaseOrder.createTime = utils.formatTime(res.data.data.purchaseOrder.createTime, 'YYYY/MM/DD HH:mm');
          }

          if (res.data.data.purchasePlan) {
            this.purchasePlan.code = res.data.data.purchasePlan.code;
            this.purchasePlan.createUserName = res.data.data.purchasePlan.createUserName;
            this.purchasePlan.createTime = utils.formatTime(res.data.data.purchasePlan.createTime, 'YYYY/MM/DD HH:mm');
            this.purchasePlan.goodsTypeName = res.data.data.purchasePlan.goodsTypeName;
            this.purchasePlan.goodsType = res.data.data.purchasePlan.goodsType;
            this.purchasePlan.typeName = res.data.data.purchasePlan.typeName;
          }

          res.data.data.purchaseMedicineInfoVoList.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            console.log(result);
            this.tableData.push(result);
          });
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handlePage(page) {
      this.page = page;
      this.getData();
    },
    handlePageSize(size) {
      this.size = size;
      this.getData();
    },
  },
  watch: {
    'purchasePlan.goodsType': function goodsTypeHandler() {
      if (this.purchasePlan.goodsType === 2) {
        this.columns.splice(3, 1, {
          title: '注册证号/备案号',
          minWidth: 124,
          tooltip: true,
          key: 'medicineInfoVoApprovalCode',
        });
      } else {
        this.columns.splice(3, 1, {
          title: '批准文号',
          key: 'medicineInfoVoApprovalCode',
          tooltip: true,
          minWidth: 116,
        });
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style lang="less" scoped>
.cancel-card{
  margin-top: 30px;
}
</style>
